export class BaseSystem {
  private maxHp: number;
  private hp: number;
  private leaksTaken: number = 0;

  constructor(initialHp: number) {
    const clamped = Math.max(1, Math.round(initialHp));
    this.maxHp = clamped;
    this.hp = clamped;
  }

  getHp(): number {
    return this.hp;
  }

  getMaxHp(): number {
    return this.maxHp;
  }

  getLeaksTaken(): number {
    return this.leaksTaken;
  }

  applyLeakDamage(amount: number = 1): number {
    const applied = Math.max(0, Math.round(amount));
    if (applied === 0 || this.hp <= 0) return this.hp;

    this.hp = Math.max(0, this.hp - applied);
    this.leaksTaken += applied;
    return this.hp;
  }

  isDepleted(): boolean {
    return this.hp <= 0;
  }

  reset(maxHp?: number): void {
    if (typeof maxHp === 'number') {
      this.maxHp = Math.max(1, Math.round(maxHp));
    }
    this.hp = this.maxHp;
    this.leaksTaken = 0;
  }
}
